import { memo, type ReactNode } from 'react';

import { ASSET_MODAL_PANEL_TITLE } from '~/constants/testIDs';
import usePrevious from '~/hooks/usePrevious';

export type ContentHeaderProps = {
  title?: string | ReactNode;
  adornment?: ReactNode;
  contentHeader?: ReactNode;
};

export const ContentHeader = memo(({ title, adornment, contentHeader }: ContentHeaderProps) => {
  const previousTitle = usePrevious(title);

  return (
    <div className="w-full ads:border-ads-gray-5 border-gray-5 border-b pr-4 pl-6">
      <div className="flex h-[60px] items-center justify-start">
        <div
          data-testid={ASSET_MODAL_PANEL_TITLE}
          className="mr-auto font-bold ads:text-metadata text-14 text-gray-10 uppercase"
        >
          {!title && previousTitle ? previousTitle : title}
        </div>
        {adornment}
      </div>
      {contentHeader}
    </div>
  );
});

ContentHeader.displayName = 'ContentHeader';
